import { defineMessages } from 'react-intl';

export const actionButtonMessages = defineMessages({
  increase: {
    id: 'quantitySelection.increase',
    defaultMessage: 'Anzahl um {step} erhöhen',
  },
  decrease: {
    id: 'quantitySelection.decrease',
    defaultMessage: 'Anzahl um {step} verringern',
  },
});
